export enum FeaturedResourcesLayout {
  COLUMN = 'column',
  ROW = 'row',
}
